<template>
<a :href="link" @click.stop="" target="_blank" class="badge" :class="{'badge-success': status === 50, 'badge-info': status === 30, 'badge-secondary': status === 10, 'badge-warning': status === 90}" v-if="status !== null">
    <div class="mb-2">{{ shipment }}</div>
    <div class="mb-2">{{ $t('tracking.status.' + status) }}</div>
    {{ $moment(date).format('DD-MM-YY') }}
</a>
</template>

<script>
export default {
    name: 'TrackingBadge',
    props: {
        link: {
            type: String,
            default: null
        },
        status: {
            type: [Number, null],
            default: null,
        },
        date: {
            type: String,
            default: null
        },
        shipment: {
            type: String,
            default: null
        }
    }
}
</script>
